import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const API = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Modal para enviar un correo al dueño de una pieza marcada como Cambio.
// Se monta cuando `publicationId` es truthy y se cierra llamando a onClose.
export default function ContactOwnerModal({ publicationId, pieceName, ownerName, onClose }) {
  const { t } = useTranslation();
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const [done, setDone] = useState(false);

  useEffect(() => {
    setMessage('');
    setErr('');
    setDone(false);
    setBusy(false);
  }, [publicationId]);

  if (!publicationId) return null;

  const send = async () => {
    setErr('');
    setBusy(true);
    try {
      await axios.post(`${API}/api/publications/${publicationId}/contact`, { message });
      setDone(true);
    } catch (e) {
      setErr(e.response?.data?.message || t('listing.contact_modal_error'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,.6)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 1000, padding: 16,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '100%', maxWidth: 480, background: 'var(--surface)',
          border: '1px solid var(--line)', borderRadius: 12, padding: 24,
        }}
      >
        <h3 style={{ margin: 0, fontSize: 18, fontWeight: 700 }}>
          {t('listing.contact_modal_title')}
        </h3>
        <p style={{ marginTop: 8, marginBottom: 4, color: 'var(--muted)', fontSize: 13 }}>
          {pieceName}{ownerName ? ` · ${ownerName}` : ''}
        </p>
        <p style={{ marginTop: 0, marginBottom: 14, color: 'var(--muted)', fontSize: 12 }}>
          {t('listing.contact_modal_subtitle')}
        </p>

        {done ? (
          <>
            <div style={{
              padding: 12, borderRadius: 8, background: 'rgba(20,184,166,.12)',
              color: 'var(--teal)', fontSize: 13, marginBottom: 14,
            }}>
              {t('listing.contact_modal_sent')}
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <button type="button" className="btn-teal" onClick={onClose}>OK</button>
            </div>
          </>
        ) : (
          <>
            <textarea
              className="light-input"
              style={{ width: '100%', minHeight: 110, resize: 'vertical' }}
              placeholder={t('listing.contact_modal_placeholder')}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              maxLength={2000}
              disabled={busy}
            />
            {err && (
              <div className="error-banner" style={{ marginTop: 10, fontSize: 12 }}>{err}</div>
            )}
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 14 }}>
              <button type="button" className="btn-ghost" onClick={onClose} disabled={busy}>
                {t('listing.contact_modal_cancel')}
              </button>
              <button type="button" className="btn-teal" onClick={send} disabled={busy}>
                {busy ? t('listing.contact_modal_sending') : t('listing.contact_modal_send')}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
